import { render, staticRenderFns } from "./view-add.vue?vue&type=template&id=a4ab5290&scoped=true&"
import script from "./view-add.vue?vue&type=script&lang=js&"
export * from "./view-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ab5290",
  null
  
)

export default component.exports